import { getEarliestDate, getLastDayofMonthBeforeBirthdayFromEmployeeId } from '@fora-monorepo/date-utils';
import { MAX_AGE_STARTDATE } from '@fora-monorepo/employer-my-pages-input-validation';

export const getMarkupStartDateRangeMax = (employeeId?: string, employmentEndDate?: string) => {
  const datesToCompare = [];

  if (employeeId) {
    // Last day of the month before they turn 100 (MAX_AGE_STARTDATE + 1)
    const maxAgeRestrictionDate = getLastDayofMonthBeforeBirthdayFromEmployeeId(employeeId, MAX_AGE_STARTDATE + 1);
    datesToCompare.push(maxAgeRestrictionDate);
  }

  if (employmentEndDate) {
    datesToCompare.push(employmentEndDate);
  }

  if (datesToCompare.length === 0) {
    return undefined;
  }

  return getEarliestDate(datesToCompare);
};
